import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {TherapyPlan} from '../models/therapy-plan.model';

@Injectable()
export class TherapyPlanAdapter implements IAdapter<TherapyPlan> {
  adaptToModel(resp: any): TherapyPlan {
    const therapyPlan: TherapyPlan = {...resp};

    therapyPlan.dates = [];
    if (therapyPlan.days) {
      const TWO = 2;
      const THREE = 3;
      therapyPlan.days.split(',').forEach(date => {
        switch (parseInt(date)) {
          case 1:
            therapyPlan.dates.push({label: 'st', value: parseInt(date)});
            break;
          case TWO:
            therapyPlan.dates.push({label: 'nd', value: parseInt(date)});
            break;
          case THREE:
            therapyPlan.dates.push({label: 'rd', value: parseInt(date)});
            break;
          default:
            therapyPlan.dates.push({label: 'th', value: parseInt(date)});
            break;
        }
      });
    }
    return therapyPlan;
  }
  adaptFromModel(data: TherapyPlan): any {
    return data;
  }
}
